

export const CarNodeButton  = ({
	type,
	price,
	onClick,
	isShown
}: {
	type: 'RESEARCH' | 'BUY' | 'DONATE',
	price: number,
	onClick: () => void,
	isShown: boolean
}) => {
	const getIcon = () => {
		switch (type) {
			case 'RESEARCH':
				return '/icons/32px/xp.png'
			case 'BUY':
				return '/icons/32px/money.png'
			case 'DONATE':
				return '/icons/32px/dp.png'
		}
	}

	const getClassNameByType = () => {
		switch (type) {
			case 'RESEARCH':
				return 'research'
			case 'BUY':
				return 'buy'
			case 'DONATE':
				return 'donate'
		}
	}

	return (
		<div 
			className={`car-node-button ${getClassNameByType()}`} 
			onClick={(e) => {e.stopPropagation(); onClick()}} 
			style={{ display: isShown ? 'flex' : 'none' }}
		> 
			<img className='car-node-button-icon' src={getIcon()} alt={type} />
			<p>{price}</p>
		</div>
	)
}